/** @format */

import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconStarFilled,
	homefieldIconStarHalf,
	homefieldIconStarOutlined
} from '@dsg-tech/homefield-angular-icons';

import { CommonModule } from '@angular/common';
import { ProductReviewsPipesModule } from '../pipes/product-reviews-pipes.module';
import { NgModule } from '@angular/core';
import { ReviewCardModule } from '../review-card/review-card.module';
import { ReviewLatestCarrouselComponent } from './review-latest-carousel.component';
import { ReviewSliderComponentModule } from '../review-slider/review-slider.module';

@NgModule({
	imports: [
		CommonModule,
		HomefieldIconLibraryModule,
		ProductReviewsPipesModule,
		ReviewCardModule,
		ReviewSliderComponentModule
	],
	declarations: [ReviewLatestCarrouselComponent],
	exports: [ReviewLatestCarrouselComponent]
})
export class ReviewLatestCarouselComponentModule {
	constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
		homefieldIconsLibraryService.registerIcons([
			homefieldIconStarFilled,
			homefieldIconStarHalf,
			homefieldIconStarOutlined
		]);
	}
}
